module.exports = __webpack_public_path__ + "img/7.d24f976a.svg";